import SentrySingleton from '@/singletons/sentry-singleton';
import * as THREE from 'three'

const ROUGHNESS = 0.5
const METALNESS = 0.1
const NORMAL_MAP_SCALE = new THREE.Vector2(-0.75, -0.75)

export default class MaterialCreateService {

    createMaterial(fragmentShader: any, normalMap: boolean, skinning: boolean, isRenderer: boolean, transparent?: boolean): THREE.ShaderMaterial {
        try {
            let mat = new THREE.ShaderMaterial({
                fragmentShader: fragmentShader,
                vertexShader: THREE.ShaderLib.standard.vertexShader,
                uniforms: THREE.UniformsUtils.clone(THREE.ShaderLib['standard'].uniforms),
                defines: {
                    USE_MAP: false,
                    USE_UV: true,
                    USE_NORMALMAP: normalMap,
                    TANGENTSPACE_NORMALMAP: normalMap,
                    USE_METALNESSMAP: false,
                    USE_ALPHAMAP: transparent || false,
                    USE_ROUGHNESSMAP: false,
                    USE_EMISSIVEMAP: false,
                    RENDERER: isRenderer
                },
                skinning: skinning,
                lights: true,
                dithering: true,
                transparent: transparent || false
            });
            mat.extensions.derivatives = true;
            return mat;
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
            return new THREE.ShaderMaterial()
        }
    }

    createColor(color: any): THREE.Color {
        return new THREE.Color(color).convertSRGBToLinear();
    }

    getRoughness() {
        return ROUGHNESS
    }

    getMetalness() {
        return METALNESS
    }

    getNormalMapScale() {
        return NORMAL_MAP_SCALE
    }
}